import i18n from '@/lang';

// 模块
export const MODULE_OBJ = Object.freeze({
  1: {
    name: i18n.t('basicData.Receivables'), // 应收
    value: 1
  },
  2: {
    name: i18n.t('basicData.payable'), // 应付
    value: 2
  },
  3: {
    name: i18n.t('receivablePayable.ImportAddCharges'), // 导入添加费用
    value: 3
  },
  4: {
    name: i18n.t('receivablePayable.ImportModifyExpenses'), // 导入修改费用
    value: 4
  },
  5: {
    name: i18n.t('receivablePayable.BatchImportClips'), // 批量导入快录
    value: 5
  },
  6: {
    name: 'CTE',
    value: 6
  },
  7: {
    name: i18n.t('receivablePayable.揽收费异常费用'),
    value: 7
  },
  8: {
    name: i18n.t('receivablePayable.ImportReceivableGeneration'), // 导入应收生成
    value: 8
  },
  12: {
    name: i18n.t('receivablePayable.Costs'), // 成本
    value: 12
  }
});

// 操作功能
export const OPERATION_OBJ = Object.freeze({
  3: {
    name: i18n.t('receivablePayable.ImportAddCharges'), // 导入添加费用
    value: 3
  },
  4: {
    name: i18n.t('receivablePayable.ImportModifyExpenses'), // 导入修改费用
    value: 4
  },
  5: {
    name: i18n.t('receivablePayable.BatchImportClips'), // 批量导入快录
    value: 5
  },
  7: {
    name: i18n.t('receivablePayable.揽收费异常费用'), // 揽收费异常费用
    value: 7
  },
  8: {
    name: i18n.t('receivablePayable.ImportReceivableGeneration'), // 导入应收生成
    value: 8
  },
  9: {
    name: i18n.t('basicData.AJD应付账户导入付款数据'), // AJD应付账户导入付款数据
    value: 9
  },
  10: {
    name: i18n.t('basicData.DSP应付账户导入付款数据'), // DSP应付账户导入付款数据
    value: 10
  },
  11: {
    name: i18n.t('basicData.安骏应付账户导入付款数据'), // 安骏应付账户导入付款数据
    value: 11
  },
  13: {
    name: i18n.t('receivablePayable.BatchDeleteExpensesByOrderNo'), // 批量导入删除费用
    value: 13
  },
  14: {
    name: i18n.t('receivablePayable.importGenerateReceipt'), // 导入生成收款单
    value: 14
  },
  15: {
    name: i18n.t('receivablePayable.batchWithdrawal'), // 批量撤回对账单
    value: 15
  }
});

// 导入状态
export const IMPORT_STATUS_OBJ = Object.freeze({
  '0': {
    name: i18n.t('newOrder.processing'), // 处理中
    value: 0,
    type: 'warning'
  },
  '1': {
    name: i18n.t('receivablePayable.AllSuccessful'), // 全部成功
    value: 1,
    type: 'success'
  },
  '2': {
    name: i18n.t('receivablePayable.AllFail'), // 全部失败
    value: 2,
    type: 'danger'
  },
  '4': {
    name: i18n.t('receivablePayable.PartiallyFailed'), // 部分失败
    value: 4,
    type: 'warning'
  }
});
